// Mock data for SystemCraft waitlist page

export const mockWaitlistCount = 1247;

export const valuePropositions = [
  {
    title: "Design Real Distributed Systems",
    description: "Build on a visual canvas with actual system components, not just boxes and arrows.",
    icon: "network"
  },
  {
    title: "Configure Real Algorithms & Schemas",
    description: "Choose actual algorithms, data structures, and define real schemas—not theoretical concepts.",
    icon: "settings"
  },
  {
    title: "Do Capacity Planning & Calculations",
    description: "Calculate actual throughput, storage, and latency—no more guessing or hand-waving.",
    icon: "calculator"
  },
  {
    title: "Answer Critical Design Questions",
    description: "Practice responding to follow-up questions just like in real system design interviews.",
    icon: "message-circle"
  },
  {
    title: "Get Deterministic Feedback",
    description: "Receive detailed, actionable feedback on your design decisions and trade-offs.",
    icon: "check-circle"
  },
  {
    title: "Practice Real Interview Scenarios",
    description: "Work through actual system design problems asked at top tech companies with realistic constraints.",
    icon: "briefcase"
  }
];

export const targetAudience = [
  "Software engineers preparing for system design interviews",
  "Backend and distributed systems engineers looking to level up their skills",
  "Engineers tired of memorizing templates without understanding trade-offs"
];

export const mockSubmitWaitlist = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock waitlist submission:', formData);
      resolve({ success: true, message: 'Successfully joined the waitlist!' });
    }, 800);
  });
};
